import { CameraFeature, CameraHandler } from ".";

export class AerialCameras {
  private cameraHandler: CameraHandler;

  constructor(cameraHandler: CameraHandler) {
    this.cameraHandler = cameraHandler;
  }

  get viewer() {
    return this.cameraHandler.viewer;
  }

  get files() {
    return this.cameraHandler.files;
  }

  getFeatureForEvent(event) {
    const minimap = this.viewer.minimap;
    const layers = this.files.map(file => file.mapLayerBackground);

    const features = minimap.map.getFeaturesAtPixel(event.pixel, {
      layerFilter: (layer: any) =>  layers.includes(layer)
    });

    // Only return the first feature
    return features.slice(0,1) as CameraFeature[];
  }
}